const CAMPAIGN_IMAGE_URL_PLACEHOLDER = "%%campaign_image_url%%";

export const normalizeImages = (campaignID, html) => {
  let result = html || "";
  let delimiters = [[`"`, `"`], [`'`, `'`], [`\\(`, `\\)`]];
  let campaignMatch = campaignID || "\\d+";

  delimiters.forEach((delimiterSet) => {
    let left = delimiterSet[0];
    let right = delimiterSet[1];
    let expressionString = `${left}http[^${left}${right}]*/campaign_images/${campaignMatch}/([^${left}${right}]+)${right}`;
    let regex = new RegExp(expressionString);
    let replacement = `${left}${CAMPAIGN_IMAGE_URL_PLACEHOLDER}$1${right}`;
    result = result.replace(regex, replacement);
  });
  return result;
};

// js-routes (>= 2.x) rejects an empty string for the required :image_name
// segment, so build the path with a sentinel filename and strip it back off to
// get the "/campaign_images/:campaign_id/" prefix the placeholder appends to.
const IMAGE_NAME_SENTINEL = "__image_name__";

export const denormalizeImages = (campaignID, html) => {
  let image_path = Routes.campaign_image_path(campaignID, IMAGE_NAME_SENTINEL).replace(IMAGE_NAME_SENTINEL, "");
  let base_url = `${document.location.protocol}//${document.location.host}${image_path}`;

  let regexp = new RegExp(RegExp.escape(CAMPAIGN_IMAGE_URL_PLACEHOLDER), "gi");

  return html && html.replace(regexp, base_url);
};
